
  export default {
    props: {
      constraints: { type: Object, default () { return {}; } },
      field: { type: String, required: true },
      modelName: { type: String, required: true },
      placeholder: { type: String, default: null },
      required: { type: Boolean, default: false },
      step: { type: Number, default: 0.01 }
    },
    computed: {
      attribute: {
        get () {
          return this.$formGet(this.modelName, this.field);
        },
        set (value) {
          if (value < 0) {
            value = 0;
          } else if (value > 100) {
            value = 100;
          }
          const h = {};
          h[this.field] = value;
          this.$formSet(this.modelName, h);
        }
      },
      unmaskedValue () {
        return parseInt(this.attribute.toString().replace(/\D/g, ''), 10);
      }
    }
  };
